export const generalBillPaymentsConstants = {
  PAYEE_CATEGORIES_LIST_REQUEST: "PAYEE_CATEGORIES_LIST_REQUEST",
  PAYEE_CATEGORIES_LIST_COMPLETE: "PAYEE_CATEGORIES_LIST_COMPLETE",
  PAYEE_CATEGORIES_LIST_ERROR: "PAYEE_CATEGORIES_LIST_ERROR",

  PAYEE_TYPES_LIST_REQUEST: "PAYEE_TYPES_LIST_REQUEST",
  PAYEE_TYPES_LIST_COMPLETE: "PAYEE_TYPES_LIST_COMPLETE",
  PAYEE_TYPES_LIST_ERROR: "PAYEE_TYPES_LIST_ERROR",

  PAYABLE_LIST_REQUEST: "PAYABLE_LIST_REQUEST",
  PAYABLE_LIST_COMPLETE: "PAYABLE_LIST_COMPLETE",
  PAYABLE_LIST_ERROR: "PAYABLE_LIST_ERROR",

  SET_SLECETED_CATEGORY: "SET_SLECETED_CATEGORY",
  SET_SELECTED_PAYEE_TYPE: "SET_SELECTED_PAYEE_TYPE",

  SET_BILLER_SCREEN_TYPE: "SET_BILLER_SCREEN_TYPE",

  SET_PAYABE_ACCOUNTS: "SET_PAYABE_ACCOUNTS",

  SET_PAYABE_CARDS: "SET_PAYABE_CARDS",
  SET_SELECTED_PAYMENT_OPTION: "SET_SELECTED_PAYMENT_OPTION",
  SET_PAY_ACCOUNT_NUMBER: "SET_PAY_ACCOUNT_NUMBER",
  SET_CARD_TYPE: "SET_CARD_TYPE",
  SET_PAY_BALANCE: "SET_PAY_BALANCE",
  SET_PAYEE_TYPE: "SET_PAYEE_TYPE",
  SET_BILL_ACCOUNT_NUMBER: "SET_BILL_ACCOUNT_NUMBER",
  SET_BILL_AMOUNT: "SET_BILL_AMOUNT",
  SET_BILL_OUTSTANDING_AMOUNT: "SET_BILL_OUTSTANDING_AMOUNT",
  VALIDATE_BILL_ACCOUNT_NUMBER_REQUEST: "VALIDATE_BILL_ACCOUNT_NUMBER_REQUEST",
  VALIDATE_BILL_ACCOUNT_NUMBER_COMPLETE:
    "VALIDATE_BILL_ACCOUNT_NUMBER_COMPLETE",
  VALIDATE_BILL_ACCOUNT_NUMBER_ERROR: "VALIDATE_BILL_ACCOUNT_NUMBER_ERROR",
  VALIDATE_BILL_AMOUNT_REQUEST: "VALIDATE_BILL_AMOUNT_REQUEST",
  VALIDATE_BILL_AMOUNT_COMPLETE: "VALIDATE_BILL_AMOUNT_COMPLETE",
  VALIDATE_BILL_AMOUNT_ERROR: "VALIDATE_BILL_AMOUNT_ERROR",
  GENERAL_PAY_BILL_REQUEST: "GENERAL_PAY_BILL_REQUEST",
  GENERAL_PAY_BILL_COMPLETE: "GENERAL_PAY_BILL_COMPLETE",
  GENERAL_PAY_BILL_ERROR: "GENERAL_PAY_BILL_ERROR",
  OTP_CONFIRMATION_REQUEST: "OTP_CONFIRMATION_REQUEST",
  OTP_CONFIRMATION_COMPLETE: "OTP_CONFIRMATION_COMPLETE",
  OTP_CONFIRMATION_ERROR: "OTP_CONFIRMATION_ERROR",
  CLEAR_GENAREL_BILLER: "CLEAR_GENAREL_BILLER",
  TRY_AGAIN_BILL_PAYMENT: "TRY_AGAIN_BILL_PAYMENT",

  SET_RELOAD_BILLER_CATEGORIES: "SET_RELOAD_BILLER_CATEGORIES",

  BILL_PAYMENTS_OTP_RESEND_REQUEST: "BILL_PAYMENTS_OTP_RESEND_REQUEST",
  BILL_PAYMENTS_OTP_RESEND_COMPLETE: "BILL_PAYMENTS_OTP_RESEND_COMPLETE",
  BILL_PAYMENTS_OTP_RESEND_ERROR: "BILL_PAYMENTS_OTP_RESEND_ERROR",

  SET_BILLER_TRANSACTION_INITIATE_DATA: "SET_BILLER_TRANSACTION_INITIATE_DATA",

  BILLER_RECURRING_ONETIME: "ONETIME",

  SCHEDULED_BILL_PAYMENT_SUCCESS_STATUS: "success",
  SCHEDULED_BILL_PAYMENT_PENDING_STATUS: "pending",
  SCHEDULED_BILL_PAYMENT_FAILED_STATUS: "failed",
};
